import { applySourceMiddleware } from './source/source';

export const applyMiddlewares = () => {
  applySourceMiddleware();
  return true;
};
